export enum SECTION {
	DASHBOARD,
	FIELDS,
	EVALUATION,
	REPORTS,
	ACCESS
}

export enum RIGHT {
	ADMIN = "ADMIN",
	FIELDS = "FIELDS",
	EVALUATION = "EVALUATION",
	REPORT = "REPORT",
	READ = "READ"
}
